import React, { useEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { LICENCE_KEY } from "../constants/charts";

am4core.addLicense(LICENCE_KEY);

export default function AmHeatmapChart({ id, data, color }) {

  const chartRef = useRef(null);

  useEffect(() => {

    const chart = am4core.create(id, am4charts.XYChart);
    chart.data = data;

    // X Axis (Hour)
    const xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    xAxis.dataFields.category = "hour";
    xAxis.renderer.grid.template.disabled = true;
    xAxis.renderer.labels.template.fontSize = 10;
	xAxis.renderer.minGridDistance = 10;

    // Y Axis (Day)
    const yAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    yAxis.dataFields.category = "day";
    yAxis.renderer.grid.template.disabled = true;
    yAxis.renderer.labels.template.fontSize = 10;
	yAxis.renderer.minGridDistance = 10;

    // Series
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.categoryX = "hour";
    series.dataFields.categoryY = "day";
    series.dataFields.value = "value";

    series.columns.template.width = am4core.percent(100);
    series.columns.template.height = am4core.percent(100);
    series.columns.template.strokeWidth = 0;

    // 🔥 Heat rules (this is the magic)
    series.heatRules.push({
      property: "fill",
      target: series.columns.template,
      min: am4core.color("#f0f0f0"),
      max: am4core.color(color)
    });

    // Tooltip
    series.columns.template.tooltipText =
      "{day} {hour}:00\n[bold]{value}[/]";

    chartRef.current = chart;

    return () => {
      chart.dispose();
    };

  }, [id, data, color]);

  return (
    <div style={cardStyle}>
      <div id={id} style={{ width: "100%", height: "100%" }}></div>
    </div>
  );
}

const cardStyle = {
  width: "100%",
  height: "100%"
};